module.exports = __webpack_public_path__ + "img/icon_map_3_off_111.9a76e96b.png";